import React, { useState, useEffect } from 'react';
import Shared from 'screens/shared';
import { Paper, Collapse } from '@mui/material';
import { useSelector } from 'react-redux';
import { actions } from 'redux/local';
import { VALIDATION, ROUTE } from 'constant';
import { _t, locations } from 'utils';
import UploadImages from './upload-images';

const getPlugOptions = (all = true) => (
  all ? [
    ['none', _t('None')],
    ['hotplug', _t('Hot Plug')],
    ['hotunplug', _t('Hot Unplug')],
    ['hotplugUnplug', _t('Hot Plug & Unplug')],
  ]
    : [
      ['none', _t('None')],
      ['hotplug', _t('Hot Plug')],
    ]
);

export default () => {
  const [openCreateForm, setOpenCreateForm] = useState(false);
  const [items, setItems] = useState([]);
  const [deleteProps, setDeleteProps] = useState('');

  const { uploadedImages = [] } = useSelector((e) => e);

  useEffect(() => {
    setItems(uploadedImages);
  }, [uploadedImages]);

  useEffect(() => {
    actions.common.setLayoutTitle({ layout: { title: _t('Images'), menu: ROUTE.DASHBOARD.IMAGES.key } });
    actions.images.getUploadedImages();
  }, []);

  const imageFields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'location',
      type: 'location',
      title: 'Region',
      disabled: true,
    },
    {
      name: 'size',
      type: 'text',
      title: 'Size',
      disabled: true,
    },
    {
      name: 'licenceType',
      type: 'dropdown',
      title: _t('OS Type'),
      options: [
        ['UNKNOWN', 'UNKNOWN'],
        ['LINUX', 'LINUX'],
        ['WINDOWS', 'WINDOWS'],
        ['WINDOWS2016', 'WINDOWS2016'],
        ['OTHER', 'DATA/OTHER OS'],
      ],
    },
    {
      name: 'description',
      type: 'textarea',
      title: _t('Description'),
    },
    {
      name: 'scaleCPU',
      type: 'dropdown',
      title: _t('Scale CPU'),
      options: getPlugOptions(false),
    },
    {
      name: 'scaleRAM',
      type: 'dropdown',
      title: _t('Scale RAM'),
      options: getPlugOptions(false),
    },
    {
      name: 'hotplugNIC',
      type: 'dropdown',
      title: _t('Hotplug NICs'),
      options: getPlugOptions(),
    },
    {
      name: 'hotplugVirtIO',
      type: 'dropdown',
      title: _t('Hotplug VirtIO'),
      options: getPlugOptions(),
    },
  ];

  const validations = [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      max: 50,
    },
    {
      name: 'description',
      type: VALIDATION.STRING,
      max: 255,
    },
  ];

  const selectToEdit = (id) => {
    const index = items.findIndex(({ id: idInner }) => idInner === id);
    items[index].isEdit = true;
    setItems([...items]);
  };

  const selectToDelete = ({ id, type }) => {
    setDeleteProps({ id, type });
  };

  const onDelete = (isDelete) => {
    if (isDelete) {
      actions.images.delete({ ...deleteProps });
      setDeleteProps({});
    } else {
      setDeleteProps({});
    }
  };

  const deselectToEdit = (id) => {
    const index = items.findIndex(({ id: idInner }) => idInner === id);
    items[index].isEdit = false;
    setItems([...items]);
  };

  const constructEditImage = (item) => {
    const {
      id,
      name,
      description,
      licenceType,
      type,
      location,
      size,

      cpuHotPlug,
      // cpuHotUnplug,
      discVirtioHotPlug,
      discVirtioHotUnplug,
      nicHotPlug,
      nicHotUnplug,
      ramHotPlug,
      // ramHotUnplug,
    } = item;

    const image = {
      id,
      name,
      description,
      licenceType,
      type,
      location,
      size,
    };

    if (cpuHotPlug === false) {
      image.scaleCPU = 'none';
    } else if (cpuHotPlug === true) {
      image.scaleCPU = 'hotplug';
    }

    if (ramHotPlug === false) {
      image.scaleRAM = 'none';
    } else if (ramHotPlug === true) {
      image.scaleRAM = 'hotplug';
    }

    if (nicHotPlug === false && nicHotUnplug === false) {
      image.hotplugNIC = 'none';
    } else if (nicHotPlug === true && nicHotUnplug === false) {
      image.hotplugNIC = 'hotplug';
    } else if (nicHotPlug === false && nicHotUnplug === true) {
      image.hotplugNIC = 'hotunplug';
    } else if (nicHotPlug === true && nicHotUnplug === true) {
      image.hotplugNIC = 'hotplugUnplug';
    }

    if (discVirtioHotPlug === false && discVirtioHotUnplug === false) {
      image.hotplugVirtIO = 'none';
    } else if (discVirtioHotPlug === true && discVirtioHotUnplug === false) {
      image.hotplugVirtIO = 'hotplug';
    } else if (discVirtioHotPlug === false && discVirtioHotUnplug === true) {
      image.hotplugVirtIO = 'hotunplug';
    } else if (discVirtioHotPlug === true && discVirtioHotUnplug === true) {
      image.hotplugVirtIO = 'hotplugUnplug';
    }

    return image;
  };

  const onSave = ({ id = null, ...item }) => {
    const {
      name,
      description,
      licenceType,
      type,

      hotplugNIC,
      hotplugVirtIO,
      scaleCPU,
      scaleRAM,
    } = item;

    const image = {
      properties: {
        name,
        licenceType,
      },
    };

    if (description) {
      image.properties.description = description;
    }

    if (scaleCPU === 'none') {
      image.properties.cpuHotPlug = false;
    } else if (scaleCPU === 'hotplug') {
      image.properties.cpuHotPlug = true;
    }

    if (scaleRAM === 'none') {
      image.properties.ramHotPlug = false;
    } else if (scaleRAM === 'hotplug') {
      image.properties.ramHotPlug = true;
    }

    if (hotplugNIC === 'none') {
      image.properties.nicHotPlug = false;
      image.properties.nicHotUnplug = false;
    } else if (hotplugNIC === 'hotplug') {
      image.properties.nicHotPlug = true;
      image.properties.nicHotUnplug = false;
    } else if (hotplugNIC === 'hotunplug') {
      image.properties.nicHotPlug = false;
      image.properties.nicHotUnplug = true;
    } else if (hotplugNIC === 'hotplugUnplug') {
      image.properties.nicHotPlug = true;
      image.properties.nicHotUnplug = true;
    }

    if (hotplugVirtIO === 'none') {
      image.properties.discVirtioHotPlug = false;
      image.properties.discVirtioHotUnplug = false;
    } else if (hotplugVirtIO === 'hotplug') {
      image.properties.discVirtioHotPlug = true;
      image.properties.discVirtioHotUnplug = false;
    } else if (hotplugVirtIO === 'hotunplug') {
      image.properties.discVirtioHotPlug = false;
      image.properties.discVirtioHotUnplug = true;
    } else if (hotplugVirtIO === 'hotplugUnplug') {
      image.properties.discVirtioHotPlug = true;
      image.properties.discVirtioHotUnplug = true;
    }

    setTimeout(() => {
      deselectToEdit(id);
    }, 500);

    actions.images.update({ image, id, type });
  };

  return (
    <div className="screen-images screen-common m-10">
      <h3 className="screen-common-title">
        {'Images '}
        <span className="button" onClick={() => setOpenCreateForm((s) => !s)} style={{ background: 'white', borderRadius: 'var(--border-radius)' }}>
          <Shared.widgets.Icon name="upload" />
          {_t('Upload Image')}
        </span>
      </h3>
      <Collapse in={openCreateForm} collapsedSize="0px">
        <Paper style={{ marginTop: 20 }}>
          {openCreateForm && (
            <UploadImages />
          )}
        </Paper>
      </Collapse>
      <div className="cards">
        {items.map((item) => {
          const {
            id, name, type, isEdit = false, state, size, licenceType, location,
          } = item;
          const { image: locImage = '', name: locName = '' } = locations[location] || {};

          return (
            <div key={id}>
              <Collapse in={isEdit} collapsedSize="0px">
                <Paper style={{ marginTop: 20 }}>
                  {isEdit && (
                    <Shared.forms.Form
                      fields={imageFields}
                      fieldsValues={constructEditImage(item)}
                      onSubmit={onSave}
                      onCancel={() => deselectToEdit(id)}
                      validations={validations}
                    />
                  )}
                </Paper>
              </Collapse>
              {!isEdit && (
                <Shared.widgets.CardBasic
                  key={id}
                  icon={type === 'OWN' ? 'compact-disc' : 'camera-retro'}
                  title={name}
                  details={(
                    <>
                      <div>
                        <span>{`OS: ${licenceType}`}</span>
                        <span style={{ marginLeft: 15 }}>{`Size: ${size} GB`}</span>
                      </div>
                      <div>
                        <span>
                          <img src={locImage} alt="country logo" style={{ width: 15, height: 15, verticalAlign: 'middle' }} />
                          <span style={{ position: 'relative', top: 1, left: 5 }}>{locName}</span>
                        </span>
                      </div>

                    </>
                  )}
                  isLoader={state !== 'AVAILABLE'}
                  actionButtons={{
                    edit: () => selectToEdit(id),
                    delete: () => selectToDelete({ id, type }),
                  }}
                />
              )}
            </div>
          );
        }).reverse()}
        {!items.length && <Shared.utilities.NoData />}
      </div>
      <Shared.dialog.Confirm show={!!deleteProps.id} onClose={onDelete} />
    </div>
  );
};
